import { ActivatedRouteSnapshot, ResolveFn, Route, Router, RouterStateSnapshot } from '@angular/router';
import { inject } from '@angular/core';
import { DienstleistungAdminBearbeitungService } from './dienstleistung-admin-bearbeitung.service';
import { DIENSTLEISTUNG_ADMIN_BEARBEITUNG_PATH, DIENSTLEISTUNGEN_PATH } from '../../mgs-path-defs';
import { partnerResolver } from '../../partner/partner.resolver';

const dienstleistungAdminBearbeitungResolver: ResolveFn<void> = async (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const router = inject(Router);
  const dienstleistungAdminBearbeitungService = inject(DienstleistungAdminBearbeitungService);
  const code = route.params['code'];
  if (code) {
    return dienstleistungAdminBearbeitungService.load(code);
  } else {
    void router.navigate(['/' + DIENSTLEISTUNGEN_PATH]);
  }
};

export const dienstleistungAdminBearbeitungRoute: Route = {
  path: DIENSTLEISTUNG_ADMIN_BEARBEITUNG_PATH + '/:code',
  title: 'Dienstleistung Admin Bearbeitung',
  loadComponent: () => import('./dienstleistung-admin-bearbeitung.component'),
  resolve: { dienstleistungAdminBearbeitung: dienstleistungAdminBearbeitungResolver, partner: partnerResolver }
};
